<div [ngClass]="{ 'app-loading': state.isLoading }">
  <y42-status-indicator></y42-status-indicator>
  <router-outlet></router-outlet>
</div>
